import React, { useState } from "react";
import styles from "./NoteExpertGeneralPageDecisionsMobile.module.css";
import arrowLeft from "../../../images/arrows/note-expert-feedbacks-arrowleft-mobile.svg";
import arrowRight from "../../../images/arrows/note-expert-feedbacks-arrowright-mobile.svg";

function NoteExpertGeneralPageDecisionsMobile({
  children,
  decisionsForMobile,
}) {
  const [offset, setOffset] = useState(0);

  const handleLeftArrowClick = () => {
    setOffset((currentOffset) => {
      const newOffset = currentOffset + 294;

      return Math.min(newOffset, 0);
    });
    console.log(offset);
  };

  const handleRightArrowClick = () => {
    setOffset((currentOffset) => {
      const newOffset = currentOffset - 294;

      const maxOffset = -(294 * (children.length - 1));

      return Math.max(newOffset, maxOffset);
    });
    console.log(offset);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.buttons}>
        {offset === 0 ? (
          <div className={styles.emptyButton}></div>
        ) : (
          <img
            onClick={handleLeftArrowClick}
            src={arrowLeft}
            alt="стрелка влево"
          />
        )}
        {-(294 * decisionsForMobile.length - 294) === offset ? (
          <div className={styles.emptyButton}></div>
        ) : (
          <img
            onClick={handleRightArrowClick}
            src={arrowRight}
            alt="стрелка вправо"
          />
        )}
      </div>
      <ul
        style={{
          transform: `translateX(${offset}px)`,
        }}
        className={styles.list}
      >
        {children}
      </ul>
    </div>
  );
}

export default NoteExpertGeneralPageDecisionsMobile;
